import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalRequestEditDialog',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any) {





return { __sfc: true, }
}

})